import { Col, Row } from "react-bootstrap";
import { connect } from "react-redux";
import { UPDATE_CURRENT_STEP } from "../store/actions/form";
import { scrollToTop } from "../utils/scroll";
import { actStatementMesssage } from "../utils/confirmationMessage";
function ActStatement({  updateCurrentStep , currentStep}) {

  const onSubmit = (data) => {
    updateCurrentStep(++currentStep);
    scrollToTop("box-wrapper");
  };
  const onBack = (_) => {
    updateCurrentStep(--currentStep);
    scrollToTop("box-wrapper");
  };

  return (
    <Row>
      <Col>
        <form id="act-statement-form" onSubmit={onSubmit}>
          <Row>
            <Col md="12">
              <h3 className="section-heading mt-4">PRIVACY ACT STATEMENT </h3>
            </Col>
          </Row>

          <Row>
            <div className="mb-4">
              {actStatementMesssage('paragraphOne')} 
            </div>
            <div className="mb-4">
              {actStatementMesssage('paragraphTwo')}
              
              <div style={{ height: '1rem' }} />
              
              <ul style={{ listStyleType: 'disc', paddingLeft: '1.25rem' }}>
                <li>{actStatementMesssage('listOne')}</li>
                <li>{actStatementMesssage('listTwo')}</li>
                <li>{actStatementMesssage('listThree')}</li>
                <li>{actStatementMesssage('listFour')} <a href={actStatementMesssage("fbiApplicantRightsLink")} target="_blank" rel="noopener noreferrer">
                  {actStatementMesssage("fbiApplicantRightsLinkText")}
                </a>.</li>
                <li>{actStatementMesssage('listFive')} <a href={actStatementMesssage("fbiPrivacyActLink")} target="_blank" rel="noopener noreferrer">
                  {actStatementMesssage("fbiPrivacyActLinkText")}
                </a>.</li>
              </ul>
            
            </div>
          </Row>
          <Row className="mt-4 mb-3">
            <Col md="12">
              <input
                type="button"
                className="btn btn-outline-primary"
                value="Back"
                onClick={onBack}
              />
              <input type="submit" className="btn btn-primary" value="Next" />
            </Col>
          </Row>
        </form>
      </Col>
    </Row>
  );
}

function mapStateToProps({ values, apiData , currentStep}) {
  return {
    initialValues: values,
    apiData,
    currentStep
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateCurrentStep: (value) =>
      dispatch({ type: UPDATE_CURRENT_STEP, value }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ActStatement);
